import React from 'react'
import {QuizData} from './quiz/QuizData'
import Quiz from 'react-quiz-component'

function quiz() {
  return (
    <>
    <div className='iframesContainer'>
    <img alt="" className="background" src="https://st3.depositphotos.com/6513598/18890/v/1600/depositphotos_188904790-stock-illustration-blackboard-inscribed-with-scientific-formulas.jpg" />
            
    <Quiz className="quiz" quiz={QuizData} showInstantFeedback={true} continueTillCorrect={true} />
    </div>
    </>
  )
}

export default quiz